// components/DashboardHeader.js
import { AppBar, Toolbar, IconButton, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';

const HeaderPage = ({ onOpenMenu, toggleSlider }) => {
  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: '#1e1e2f',
        zIndex: (theme) => theme.zIndex.drawer -1
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        {/* Top-left menu button */}
        <IconButton
          edge="start"
          color="inherit"
          onClick={onOpenMenu}
          sx={{ ml: 1 }}
        >
          <MenuIcon />
        </IconButton>

        {/* Centered title */}
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1, textAlign: 'center' }}
        >
          ECOWATCH360
        </Typography>

        {/* Top-right leaf button */}
        <IconButton
          edge="end"
          color="inherit"
          onClick={toggleSlider}
          sx={{ mr: 1 }}
        >
          <EnergySavingsLeafIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default HeaderPage;
